import { render, staticRenderFns } from "./LayoutProyecto.vue?vue&type=template&id=4cd75ca9"
import script from "./LayoutProyecto.vue?vue&type=script&lang=js"
export * from "./LayoutProyecto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports